import { Districts } from "@/models/facility/Districts";

export const facilityDistricts: Districts[] = [
  {
    value: "D1",
    text: "District 1"
  },
  {
    value: "D2",
    text: "District 2"
  },
  {
    value: "D3",
    text: "District 3"
  },
  {
    value: "D4",
    text: "District 4"
  },
  {
    value: "D5",
    text: "District 5"
  },
  {
    value: "D6",
    text: "District 6"
  },
  {
    value: "D7",
    text: "District 7"
  },
  {
    value: "D8",
    text: "District 8"
  },
  {
    value: "D9",
    text: "District 9"
  },
  {
    value: "D10",
    text: "District 10"
  }
];
